import { Directive, ElementRef, input, effect, inject } from '@angular/core';
import { USER_DEFAULT_AVATAR } from '../constants';

@Directive({
  selector: 'img[coreAvatar]',
})
export class AvatarDirective {
  private el = inject(ElementRef);

  coreAvatar = input<string | null | undefined>(null);

  constructor() {
    effect(() => {
      this.el.nativeElement.src = this.coreAvatar() || USER_DEFAULT_AVATAR;
    });
  }
}
